module.exports = __webpack_public_path__ + "static/media/reports_actuary.33d6e5ff.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/reports_actuary.md
// module id = 1108
// module chunks = 0